import { createBrowserRouter } from 'react-router-dom'

import Checkout from './routes/checkout/Checkout'
import CheckoutMenu from './routes/checkout/components/CheckoutMenu'
import Home from './routes/home/Home'
import Translation from './routes/language/Translation'
import ManageEmployees from './routes/manage/components/ManageEmployees'
import ManageInventory from './routes/manage/components/ManageInventory'
import ManageMenu from './routes/manage/components/ManageMenu'
import ManageSales from './routes/manage/components/ManageSales'
import Manage from './routes/manage/Manage'

const router = createBrowserRouter([
  {
    path: '/',
    element: <Checkout />,
    children: [
      {
        path: '/',
        element: <Home />,
      },
      {
        path: '/translate',
        element: <Translation />,
      },
      {
        path: '/:menuCategoryName',
        element: <CheckoutMenu />,
      },
    ],
  },
  {
    path: '/manage',
    element: <Manage />,
    children: [
      {
        path: '/manage/sales',
        element: <ManageSales />,
      },
      {
        path: '/manage/inventory',
        element: <ManageInventory />,
      },
      {
        path: '/manage/menu',
        element: <ManageMenu />,
      },
      {
        path: '/manage/employees',
        element: <ManageEmployees />,
      },
    ],
  },
])

export default router
